var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReduce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4924_33962)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8C5 6.34315 6.34315 5 8 5H20C21.6569 5 23 6.34315 23 8V20C23 21.6569 21.6569 23 20 23H8C6.34315 23 5 21.6569 5 20V8ZM10.4587 16.0015L7 19.4682L8.52814 21L11.988 17.5355L14 19.5513L13.9847 14.0175L8.462 14L10.4587 16.0015ZM21 8.53181L17.5413 11.9985L19.538 14L14.0153 13.9825L14 8.44868L16.012 10.4645L19.4719 7L21 8.53181Z",
    fill: "url(#paint0_linear_4924_33962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70503 21.1767L11.9879 17.8894L13.8231 19.7279L14.2517 20.1573L14.25 19.5506L14.2353 14.2332L19.5372 14.25L20.1424 14.2519L19.715 13.8234L17.8944 11.9985L21.177 8.70839L21.3531 8.53182L21.177 8.35525L19.6488 6.82344L19.472 6.64612L19.295 6.82334L16.0121 10.1106L14.1769 8.27207L13.7483 7.84266L13.75 8.44937L13.7647 13.7668L8.46279 13.75L7.85755 13.7481L8.28501 14.1766L10.1056 16.0015L6.82302 19.2916L6.64686 19.4682L6.82301 19.6447L8.35115 21.1766L8.52804 21.3539L8.70503 21.1767ZM5.25 8C5.25 6.48122 6.48122 5.25 8 5.25H20C21.5188 5.25 22.75 6.48122 22.75 8V20C22.75 21.5188 21.5188 22.75 20 22.75H8C6.48122 22.75 5.25 21.5188 5.25 20V8Z",
    stroke: "url(#paint1_linear_4924_33962)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4924_33962",
    x: 4,
    y: 5,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4924_33962"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4924_33962",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4924_33962",
    x1: 14,
    y1: 5,
    x2: 14,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4924_33962",
    x1: 14,
    y1: 5,
    x2: 14,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReduce);
export default __webpack_public_path__ + "static/media/ic-reduce.f66080077a68e43c5101516fd46cf5ba.svg";
export { ForwardRef as ReactComponent };